import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import {
  useAllChallengeNames,
  useAllFundNames,
  useFundAvalaibilityData,
} from "../../lib/hooks";
import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Alert,
  Autocomplete,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../../styles/charts/chartStyle.module.css";
import { Box } from "@mui/system";
import { tickAmount, toShortNumber, titleStyler } from "../../lib/util";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "./twitter/TwitterWordCloud";
import { desc } from "../../lib/chartDescription";

const title = "Fund Availability";

export default function FundAvailability() {
  const [fund_id, setFund_id] = useState<any>(-1);
  const [challenge_id, setChallenge_id] = useState<{
    label: string;
    id: number;
  } | null>(null);

  let { axisTitleStyle, markerSize, axisLabelStyle } = titleStyler();

  const {
    allChallengeNames,
    loading: allChallengeNameLoading,
    error: allChallengeNameError,
  } = useAllChallengeNames();

  let {
    loading: fundNameLoading,
    allFundNames,
    error: fundNamError,
  } = useAllFundNames();

  const { loading, error, fundAvailabilityData } = useFundAvalaibilityData(
    challenge_id?.id as number
  );

  useEffect(() => {
    if (allChallengeNameLoading) {
      return;
    }

    !allChallengeNameError &&
      setChallenge_id({
        label: `${allChallengeNames[0].fund_name}: ${allChallengeNames[0].challenge_name}`,
        id: allChallengeNames[0].challenge_id,
      });

    //eslint-disable-next-line
  }, [allChallengeNameLoading]);

  let series = [
    // Make sure to use scatter first as it is not rendering if used in other way, may be apexchart issue
    {
      name: "Funded",
      type: "scatter",
      data:
        !loading && error === null
          ? fundAvailabilityData
              .filter((item) => item.proposal_status === "Funded")
              .map((item) => {
                return [item.ranking, item.amount_requested];
              })
          : [],
    },
    {
      name: "Overbudget",
      type: "scatter",
      data:
        !loading && error === null
          ? fundAvailabilityData
              .filter((item) => item.proposal_status === "Overbudget")
              .map((item) => {
                return [item.ranking, item.amount_requested];
              })
          : [],
    },
    {
      name: "Not Approved",
      type: "scatter",
      data:
        !loading && error === null
          ? fundAvailabilityData
              .filter((item) => item.proposal_status === "Not Approved")
              .map((item) => {
                return [item.ranking, item.amount_requested];
              })
          : [],
    },
    {
      name: "Remaining Budget",
      type: "area",
      data:
        !loading && error === null
          ? fundAvailabilityData.map((item) => {
              return [item.ranking, item.fund_availability];
            })
          : [],
    },
  ];

  var options = {
    chart: {
      height: 500,
      // events: {
      //   mounted: function (data) {
      //     console.log("mounted");
      //     console.log(data);
      //   },
      // },
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: "category",
            headerValue: "value",
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
            title: "New Title",
          },
        },
      },
    },
    fill: {
      type: ["solid", "solid", "solid", "gradient"],
    },
    markers: {
      size: markerSize,
    },
    title: {
      text: "Fund Availability",
      align: "center",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: true,
      style: {
        fontSize: "20px",
        fontWeight: "",
        color: "#263238",
      },
    },
    xaxis: {
      tickAmount: tickAmount(fundAvailabilityData.length),
      show: true,
      rotate: -30,
      rotateAlways: false,
      hideOverlappingLabels: true,
      style: axisLabelStyle,
      title: {
        text: "Ranking",
        offsetX: 0,
        offsetY: 80,
        style: axisTitleStyle,
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      tickAmount: 7,
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0,
        formatter: toShortNumber,
        style: axisLabelStyle,
      },
      title: {
        text: "Requested($)",
        offsetY: 0,
        offsetX: 5,
        style: axisTitleStyle,
      },
    },
    noData: {
      text: `${loading ? "Loading..." : "Select Atleast One Category"}`,
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      // shared: true,
      // intersect: false,
      x: {
        show: true,
        formatter: (x: any) =>
          fundAvailabilityData.filter((item: any) => item.ranking === x)[0]
            .proposal_name,
      },

      //   y: [
      //     {
      //       // show: true,
      //       formatter: (x: any) => x,
      //       // fundAvailabilityData.filter((item: any) => item.ranking === x)[0]
      //       //   .fund_depletion,
      //     },
      //     {
      //       // show: true,
      //       formatter: (x: any) => x,
      //       // fundAvailabilityData.filter((item: any) => item.ranking === x)[0]
      //       //   .fund_availability,
      //     },
      //   ],
    },
  };

  const handleChange = (event: any) => {
    if (event.target.name === "fund") {
      setFund_id(event.target.value);
      return;
    }
    setChallenge_id(event.target.value);
    return;
  };

  useEffect(() => {
    if (allChallengeNames.length === 0) {
      return;
    }
    if (fund_id !== -1) {
      let challenge_names = allChallengeNames.filter(
        (item) => item.fund_id === fund_id
      );
      setChallenge_id({
        label: `${challenge_names[0].fund_name}: ${challenge_names[0].challenge_name}`,
        id: challenge_names[0].challenge_id,
      });
    } else if (fund_id === -1) {
      setChallenge_id({
        label: `${allChallengeNames[0].fund_name}: ${allChallengeNames[0].challenge_name}`,
        id: allChallengeNames[0].challenge_id,
      });
    }
    //eslint-disable-next-line
  }, [fund_id]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => (
    <Paper elevation={3} className={styles.chartContainer}>
      <div className="horizontalCenter">
        <Typography className={styles.chartHeader}>
          Fund Availability
        </Typography>
      </div>
      <div className="horizontalCenter">
        <div className={styles.flexibleControlRow}>
          <FormControl className={styles.flexibleformControl} size="small">
            <InputLabel className={styles.flexSelectFont}>Fund</InputLabel>
            <Select
              value={fund_id}
              label="Fund "
              onChange={handleChange}
              name="fund"
              size="small"
              className={styles.flexSelectFont}
            >
              <MenuItem value={-1}>All</MenuItem>
              {!fundNameLoading &&
                fundNamError === null &&
                allFundNames.map((item) => (
                  <MenuItem
                    value={item.fund_id}
                    key={`fund-name-${item.fund_id}`}
                  >{`${item.fund_name}`}</MenuItem>
                ))}
            </Select>
          </FormControl>
          <Autocomplete
            // autoComplete

            id="combo-box-demo"
            fullWidth
            sx={{ width: "300px" }}
            options={
              fund_id !== -1
                ? allChallengeNames
                    .filter((item) => item.fund_id === fund_id)
                    .map((item) => {
                      return {
                        label: `${item.fund_name}: ${item.challenge_name}`,
                        id: item.challenge_id,
                      };
                    })
                : allChallengeNames.map((item) => {
                    return {
                      label: `${item.fund_name}: ${item.challenge_name}`,
                      id: item.challenge_id,
                    };
                  })
            }
            loading={allChallengeNameLoading}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.label}
            className={styles.flexAutoComplete}
            size={"small"}
            onChange={(event: any, newValue: any) => {
              // setValue(newValue);
              setChallenge_id(newValue);
              // console.log(newValue);
            }}
            disableClearable
            value={challenge_id ? challenge_id : (null as any)}
            renderInput={(params: any) => (
              <TextField {...params} label="Challenge" />
            )}
          />
        </div>
      </div>
      {error === null ? (
        <>
          {showMaxButton ? (
            <div style={{ width: "100%", height: "100%" }}>
              <ReactApexChart
                options={options as ApexOptions}
                series={series}
                type="scatter"
                className={styles.the_chart}
                height="100%"
              />
            </div>
          ) : (
            // <div style={{ width: "100%", height: "100%" }}>
            <ReactApexChart
              options={options as ApexOptions}
              series={series}
              type="scatter"
              className={styles.the_chart}
              // height="100%"
            />
            // </div>
          )}
        </>
      ) : (
        <Box sx={{ height: "80%" }}>
          <Alert severity="error" className="alertContainer">
            {error}
          </Alert>
        </Box>
      )}
      {getChartBottomIcons(showMaxButton, setOpen)}
      {getChartInfoIcons(desc["fund"]["fundAvailability"])}
    </Paper>
  );

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
